import type { RawParams } from "@uirouter/react";
import { CardEventCategory } from "app/pages/sales-intelligence/services/tracking/home-page/types";
import { getCrmListName } from "app/pages/sales-intelligence/sub-modules/opportunities/helpers/crmList";
import { OpportunityListTypeEnum } from "app/pages/sales-intelligence/sub-modules/opportunities/types";
import type { ListItemDto, ListsDto } from "../../../types/dto";
import type { ResultsViewModel, ResultsViewModelDeps, ViewModelMetadata } from "../../../types/models";
import type { CellProps, ListRow } from "../../../types/table";
import { getListIconName } from "../../../utils/lists/getListIconName";
import { getListPageStateParams } from "../../../utils/lists/getListPageStateParams";
import { RESULTS_LIMIT } from "../const";

const createListsResultsViewModel = ({
    data,
    resultsLimit = RESULTS_LIMIT,
}: ResultsViewModelDeps<ListsDto>): ResultsViewModel<ListRow> => {
    const { lists = [], totalCount = 0 } = data ?? {};

    const listsUnderLimit = lists.slice(0, resultsLimit);
    const resultsCount = listsUnderLimit.length;

    const presentationMetadata: ViewModelMetadata = {
        trackingCategory: CardEventCategory.Lists,
        totalResultsCount: totalCount,

        getNavigationParams(cellProps: CellProps<ListItemDto>): [string, RawParams] {
            return getListPageStateParams(cellProps);
        },
    };

    const enrichListData = (list: ListItemDto): ListRow => {
        const listName =
            list.listType === OpportunityListTypeEnum.Crm && list.crmIntegrationType && list.crmObjectType
                ? getCrmListName(list.crmIntegrationType, list.crmObjectType)
                : list.listName;

        return {
            ...list,
            listName,
            iconName: getListIconName(list),
        };
    };

    return {
        metadata: presentationMetadata,
        results: listsUnderLimit.map(enrichListData),
        areResultsOverLimit: resultsCount > 0 && resultsCount >= resultsLimit,
    };
};

export default createListsResultsViewModel;
